import React, { useEffect, useRef, useState } from "react";

export function CodeEntry({ onComplete, error, disabled }) {
  const [digits, setDigits] = useState(Array(6).fill(""));
  const [shake, setShake] = useState(false);
  const refs = useRef([]);

  useEffect(() => {
    if (error) {
      setShake(true);
      setDigits(Array(6).fill(""));
      const t = setTimeout(() => {
        setShake(false);
        refs.current[0]?.focus();
      }, 260);
      return () => clearTimeout(t);
    }
  }, [error]);

  useEffect(() => {
    refs.current[0]?.focus();
  }, []);

  const handleChange = (idx, val) => {
    const clean = val.replace(/\D/g, "").slice(0, 1);
    const next = [...digits];
    next[idx] = clean;
    setDigits(next);
    if (clean && idx < 5) refs.current[idx + 1]?.focus();
    if (next.every((d) => d !== "")) {
      onComplete(next.join(""));
    }
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !digits[idx] && idx > 0) {
      refs.current[idx - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const text = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "").slice(0, 6);
    if (text.length === 6) {
      e.preventDefault();
      const arr = text.split("");
      setDigits(arr);
      onComplete(text);
    }
  };

  return (
    <div
      className={`flex gap-3 ${shake ? "cw-shake" : ""}`}
      onPaste={handlePaste}
      data-testid="code-entry"
    >
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          value={d}
          disabled={disabled}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          className={`cw-code-box ${error ? "error" : ""}`}
          inputMode="numeric"
          maxLength={1}
          data-testid={`code-digit-${i}`}
          autoComplete="one-time-code"
        />
      ))}
    </div>
  );
}
